<ng-container *ngIf="row && item">
    <div class="d-flex flex-row justify-content-center align-items-center align-self-center align-content-between">
        <ng-container *ngIf="item.textBtn && item.textBtn.length > 0">
            <div class="flex-fill">
                <ng-container *ngFor="let key of item.textBtn" [ngTemplateOutlet]="key == ActionEventHandler.PAY ? FlatButton : TextButton" [ngTemplateOutletContext]="{key: key}"></ng-container>
            </div>
        </ng-container>
        <ng-container *ngIf="item.btnTypes && item.btnTypes.length > 0">
            <intrasense-table-action-buttons class="flex-fill" [row]="row" [item]="item" [index]="i" (onBtnClick)="btnClick($event)"></intrasense-table-action-buttons>
        </ng-container>
        <ng-container *ngIf="item.actionBtn && item.actionBtn.length > 0">
            <intrasense-table-actions class="flex-fill" [row]="row" [item]="item" [index]="i" (onBtnClick)="btnClick($event)"></intrasense-table-actions>
        </ng-container>
    </div>
</ng-container>

<ng-template #TextButton let-key="key">
    <a  class="me-3" (click)="click(i, item.type, key)">
        {{
            key == ActionEventHandler.VIEW
            ? "View Detail"
            : key
        }}
    </a>
</ng-template>


<ng-template #FlatButton let-key="key">
    <button *ngIf="key == ActionEventHandler.PAY && row['status'] == ModifiedActionStatus.PENDING" mat-flat-button class="flat-buttons btn-secondary-outline me-3" type="button" (click)="click(i, item.type, key)">
        {{key}}
    </button>
</ng-template>